export enum AppuserState {
  Active = 'Active',
  Inactive = 'Inactive'
}
